// Utility: markerDefaults.js
// Purpose: ONE shared authority for the boolean true/false marker-state defaults
// (board 50-6, package P3, design §D). Was byte-identical inline literals at
// SmartChart.jsx, ChartStylingSection.jsx, and 3 nodeVisualConfig.js defaultData
// sites (5 total) — consolidated here so a future default-colour/shape change
// is a single edit, not a 5-site hunt.

/*>>> DEFAULTS <<<*/
export const DEFAULT_MARKER_STATES = [
    { key: 'true', label: 'True', color: '#10B981', shape: 'arrowUp', position: 'belowBar', enabled: true },
    { key: 'false', label: 'False', color: '#EF4444', shape: 'arrowDown', position: 'aboveBar', enabled: false },
];

/*>>> RESOLVER <<<*/
//! R8.1 fix: `||` on an array is truthy for `[]`, so a prior `marker_states: []`
//! (e.g. a cleared override) silently froze the chart with NO markers instead of
//! falling through to the designed defaults. The `.length` guard distinguishes
//! "configured, non-empty" from "absent or emptied" — only the former short-circuits.
export const resolveMarkerStates = (visualSettings, styleOptions) => (
    visualSettings?.marker_states?.length
        ? visualSettings.marker_states
        : (styleOptions?.markerStates?.length ? styleOptions.markerStates : DEFAULT_MARKER_STATES)
);
